import type { CollectionSlug, GlobalSlug } from 'payload'
import { Groups } from '@utils/groups'
import { unique } from '@utils/objects';

// Alerts
export const AlertsSlug = 'alerts' as const;
export type AlertsSlug = CollectionSlug & typeof AlertsSlug;
export const AlertsUpdateRole: Groups = ['RH_SHAREPOINT', 'SUPORTE_SHAREPOINT', 'TI_SHAREPOINT'];

// Applications
export const ApplicationsSlug = 'applications' as const;
export type ApplicationsSlug = CollectionSlug & typeof ApplicationsSlug;
export const ApplicationsCreateRole: Groups = ['TI_SHAREPOINT'];
export const ApplicationsReadRole: Groups = ['TI_SHAREPOINT'];

// Application Auth Tokens
export const ApplicationAuthTokensSlug = 'application_auth_tokens' as const;
export type ApplicationAuthTokensSlug = CollectionSlug & typeof ApplicationAuthTokensSlug;

// Application Versions
export const ApplicationVersionsSlug = 'application_versions' as const;
export type ApplicationVersionsSlug = CollectionSlug & typeof ApplicationVersionsSlug;
export const ApplicationVersionsCreateRole: Groups = ['TI_SHAREPOINT'];
export const ApplicationVersionsReadRole: Groups = ['TI_SHAREPOINT'];

// Application Deploy Logs
export const ApplicationDeployLogsSlug = 'application_deploy_logs' as const;
export type ApplicationDeployLogsSlug = CollectionSlug & typeof ApplicationDeployLogsSlug;

// Appointments
export const AppointmentsSlug = 'appointments' as const;
export type AppointmentsSlug = CollectionSlug & typeof AppointmentsSlug;
export const AppointmentsUpdateRole: Groups = ['RH_SHAREPOINT', 'SUPORTE_SHAREPOINT', 'TI_SHAREPOINT'];
export const AppointmentsReadRole: Groups = ['RH_SHAREPOINT', 'SUPORTE_SHAREPOINT', 'TI_SHAREPOINT', 'ADMINISTRATIVO_SHAREPOINT'];

// Appointment Slots
export const AppointmentSlotsSlug = 'appointment_slots' as const;
export type AppointmentSlotsSlug = CollectionSlug & typeof AppointmentSlotsSlug;

// Caches
export const CachesSlug = 'caches' as const;
export type CachesSlug = CollectionSlug & typeof CachesSlug;

// Form Builder - Forms
export const FormBuilderFormsSlug = 'forms' as const;
export type FormBuilderFormsSlug = CollectionSlug & typeof FormBuilderFormsSlug;
export const FormBuilderFormsUpdateRole: Groups = ['RH_SHAREPOINT', 'SUPORTE_SHAREPOINT', 'TI_SHAREPOINT'];

// Form Builder - Forms Submissions
export const FormBuilderFormSubmissionsSlug = 'form_submissions' as const;
export type FormBuilderFormSubmissionsSlug = CollectionSlug & typeof FormBuilderFormSubmissionsSlug;
export const FormBuilderFormSubmissionsReadRole: Groups = ['RH_SHAREPOINT', 'SUPORTE_SHAREPOINT', 'TI_SHAREPOINT'];

// Invoice Files
export const InvoiceFilesSlug = 'invoice_files' as const;
export type InvoiceFilesSlug = CollectionSlug & typeof InvoiceFilesSlug;

// Invoice Proof Files
export const InvoiceProofFilesSlug = 'invoice_proof_files' as const;
export type InvoiceProofFilesSlug = CollectionSlug & typeof InvoiceProofFilesSlug;

// Operations
export const OperationsSlug = 'operations' as const;
export type OperationsSlug = CollectionSlug & typeof OperationsSlug;
export const OperationsReadRole: Groups = ['ESTRUTURACAO_SHAREPOINT', 'GESTAO_SHAREPOINT', 'JURIDICO_SHAREPOINT', 'OBRIGACOES_SHAREPOINT'];
export const OperationsUpdateRole: Groups = ['OBRIGACOES_SHAREPOINT', 'TI_SHAREPOINT'];

// Operation Dependence
export const OperationDependencesSlug = 'operation_dependences' as const;
export type OperationDependencesSlug = CollectionSlug & typeof OperationDependencesSlug;
export const OperationDependencesReadRole: Groups = ['ESTRUTURACAO_SHAREPOINT', 'GESTAO_SHAREPOINT', 'JURIDICO_SHAREPOINT', 'OBRIGACOES_SHAREPOINT'];
export const OperationDependencesUpdateRole: Groups = ['OBRIGACOES_SHAREPOINT'];

// Operation Dependence Events
export const OperationDependenceEventsSlug = 'operation_dependence_events' as const;
export type OperationDependenceEventsSlug = CollectionSlug & typeof OperationDependenceEventsSlug;
export const OperationDependenceEventsReadRole: Groups = ['ESTRUTURACAO_SHAREPOINT', 'GESTAO_SHAREPOINT', 'JURIDICO_SHAREPOINT', 'OBRIGACOES_SHAREPOINT'];
export const OperationDependenceEventsUpdateRole: Groups = ['OBRIGACOES_SHAREPOINT'];

// Operation Entities
export const OperationEntitiesSlug = 'operation_entities' as const;
export type OperationEntitiesSlug = CollectionSlug & typeof OperationEntitiesSlug;
export const OperationEntitiesUpdateRole: Groups = ['OBRIGACOES_SHAREPOINT'];

// Operation Resource Declarations
export const OperationResourceDeclarationsSlug = 'operation_resource_declarations' as const;
export type OperationResourceDeclarationsSlug = CollectionSlug & typeof OperationResourceDeclarationsSlug;
export const OperationResourceDeclarationsReadRole: Groups = ['ESTRUTURACAO_SHAREPOINT', 'GESTAO_SHAREPOINT', 'JURIDICO_SHAREPOINT', 'OBRIGACOES_SHAREPOINT'];
export const OperationResourceDeclarationsUpdateRole: Groups = ['OBRIGACOES_SHAREPOINT'];

// Operation Resource Declaration Items
export const OperationResourceDeclarationItemsSlug = 'operation_resource_declaration_items' as const;
export type OperationResourceDeclarationItemsSlug = CollectionSlug & typeof OperationResourceDeclarationItemsSlug;

// Originators
export const OriginatorsSlug = 'originators' as const;
export type OriginatorsSlug = CollectionSlug & typeof OriginatorsSlug;
export const OriginatorsReadRole: Groups = ['COMERCIAL_SHAREPOINT'];
export const OriginatorsUpdateRole: Groups = ['COMERCIAL_SHAREPOINT'];
export const OriginatorsDeleteRole: Groups = ['INTRANET_ADMIN', 'COMERCIAL_SHAREPOINT'];

// Originator Companies
export const OriginatorCompaniesSlug = 'originator_companies' as const;
export type OriginatorCompaniesSlug = CollectionSlug & typeof OriginatorCompaniesSlug;

// Pictures
export const PicturesSlug = 'pictures' as const;
export type PicturesSlug = CollectionSlug & typeof PicturesSlug;

// Recognitions
export const RecognitionsSlug = 'recognitions' as const;
export type RecognitionsSlug = CollectionSlug & typeof RecognitionsSlug;
export const RecognitionsReadRole: Groups = ['RH_SHAREPOINT'];

// Recognition Reactions
export const RecognitionReactionsSlug = 'recognition_reactions' as const;
export type RecognitionReactionsSlug = CollectionSlug & typeof RecognitionReactionsSlug;
export const RecognitionReactionsReadRole: Groups = ['RH_SHAREPOINT'];

// Policy Documents
export const PolicyDocumentsSlug = 'policy_docs' as const;
export type PolicyDocumentsSlug = CollectionSlug & typeof PolicyDocumentsSlug;

// Policies
export const PoliciesSlug = 'policies' as const;
export type PoliciesSlug = CollectionSlug & typeof PoliciesSlug;
export const PoliciesUpdateRole: Groups = ['COMPLIANCE_SHAREPOINT'];

// HR Info Categories (Informativos RH - Seções)
export const HRInfoCategoriesSlug = 'hr_info_categories' as const;
export type HRInfoCategoriesSlug = CollectionSlug & typeof HRInfoCategoriesSlug;

// HR Info Documents (Informativos RH - Versões)
export const HRInfoDocumentsSlug = 'hr_info_docs' as const;
export type HRInfoDocumentsSlug = CollectionSlug & typeof HRInfoDocumentsSlug;

// HR Infos (Informativos RH)
export const HRInfosSlug = 'hr_infos' as const;
export type HRInfosSlug = CollectionSlug & typeof HRInfosSlug;
export const HRInfosUpdateRole: Groups = ['RH_SHAREPOINT'];

// Posts
export const PostsSlug = 'posts' as const;
export type PostsSlug = CollectionSlug & typeof PostsSlug;
export const PostsUpdateRole: Groups = ['ADMINISTRATIVO_SHAREPOINT', 'RH_SHAREPOINT', 'MARKETING_SHAREPOINT'];

// Post Categories
export const PostCategoriesSlug: CollectionSlug = 'post_categories' as const;
export type PostCategoriesSlug = typeof PostCategoriesSlug;

// Push Subscriptions
export const PushSubscriptionsSlug: CollectionSlug = 'push_subscriptions' as const;
export type PushSubscriptionsSlug = typeof PushSubscriptionsSlug;

// Settings
export const SettingsSlug: GlobalSlug = 'settings' as const;
export type SettingsSlug = typeof SettingsSlug;
export const AdminSettingsUpdateRole: Groups = ['TI_SHAREPOINT'];
export const HomePageSettingsUpdateRole: Groups = ['RH_SHAREPOINT', 'TI_SHAREPOINT'];

// Links
export const LinksSlug = 'links' as const;
export type LinksSlug = CollectionSlug & typeof LinksSlug;
export const LinksUpdateRole: Groups = ['TI_SHAREPOINT'];

// Training Reports
export const TrainingReportsSlug: CollectionSlug = 'training_reports' as const;
export type TrainingReportsSlug = typeof TrainingReportsSlug;

// Users
export const UsersSlug: CollectionSlug = 'users' as const;
export type UsersSlug = typeof UsersSlug;

// All WorkspaceRoles
export const WorkspaceRoles: Groups = unique([
  ...AlertsUpdateRole,
  ...AppointmentsUpdateRole,
  ...AppointmentsReadRole,
  ...OperationsReadRole,
  ...OperationsUpdateRole,
  ...OperationDependencesReadRole,
  ...OperationDependencesUpdateRole,
  ...OperationDependenceEventsReadRole,
  ...OperationDependenceEventsUpdateRole,
  ...OperationEntitiesUpdateRole,
  ...OperationResourceDeclarationsReadRole,
  ...OperationResourceDeclarationsUpdateRole,
  ...OriginatorsReadRole,
  ...OriginatorsUpdateRole,
  ...OriginatorsDeleteRole,
  ...PoliciesUpdateRole,
  ...HRInfosUpdateRole,
  ...LinksUpdateRole,
  ...PostsUpdateRole,
  ...AdminSettingsUpdateRole,
  ...HomePageSettingsUpdateRole,
  'INTRANET_ADMIN'
]);
